import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { MDBBtn, MDBCol } from "mdbreact";
import BootstrapTable from "react-bootstrap-table-next";
import { BootstrapTable as BootstrapTableOld, TableHeaderColumn } from "react-bootstrap-table";
import { Alert, Alignment, Button, FormGroup, HTMLSelect, InputGroup } from "@blueprintjs/core";
import { formatCnpj } from "../../utils";
import moment from "moment";
import { DateRangePicker30 } from "../utils/DateRangePicker30";
import { toast } from "react-toastify";
import { Pager } from "../utils/Pager";
import ReactJson from "react-json-view";
import { BotsAdminStore } from "../../stores/admin/BotsAdminStore";
import { getOptions, getTag, options } from "../utils/getStatus";
import { IconButton } from "@mui/material";
import LoadingModal from "../loading/LoadingModal";
import { DefaultSelect, filterItens, renderItens } from "../utils/DefaultSelect";

interface state {

  date1: string,
  date2: string

}

@observer
export class BotsAdminPage extends React.Component<{}, state> {

  obs = observable({
    selectedPeriod: [] as any,
    open_create: false as boolean,
    selectedRows: [] as any,
    allSelected: false as boolean,
    tipo: {} as {cod: string, descricao: string},
    status: "" as string,
    finalizado: "todos" as string,
    loading: false as boolean,
    erro: "todos" as string,
    cnpj: "" as string,
    id: "" as string,
    task_id: "" as string,
    conta_id: "" as string,
    open_erros_bots: false as boolean,
    erros_solicitacoes: [] as any,
    open_detalhes: false as boolean,
    tarefa: {} as any,
    loading_download: false as boolean,
    loading_solicitacoes: false as boolean
  })

  constructor(props) {
    super(props);
    this.state = { date1: "", date2: "" }
  }

  async componentDidMount() {
    AppStore.setTitle("Gerenciamento de Tarefas");

    BotsAdminStore.obs.tabelaBots = []
    BotsAdminStore.obs.currentPageBot = 1
    BotsAdminStore.obs.length_bots = 0
  }

  handleRestart = async () => {

    const selectedRows = this.obs.selectedRows;

    if (selectedRows.length === 0) {
      toast.warning("Por favor, selecione pelo menos uma tarefa para reiniciar.", {});
      return;
    }

    const okTasks = selectedRows.filter(row => {
      if (row.tipo === "sitfis") {
        return row?.status !== 4 && row?.status !== 2;
      }

      if (["pgdas", "gera_das", "mudanca_regime", "caixapostal"].includes(row.tipo)) {
        return row?.status !== 2;
      }

      return true;
    });

    if (selectedRows.length !== okTasks.length) {

      toast.error(`Tarefas concluídas e enviadas à SERPRO não podem ser reiniciadas.`);

    }

    let params = {
      itens: okTasks
    }

    this.obs.loading = true

    let resp: any = await BotsAdminStore.handleRestartBots(params)

    this.obs.selectedRows = []

    this.handleBuscaClick()

    if (resp?.length > 0) {

      this.obs.erros_solicitacoes = resp

      this.obs.open_erros_bots = true

    }

    this.obs.selectedRows = []

    this.obs.loading = false

  };

  handlePageChange = async (page: number) => {

    if (!this.obs.tipo.cod) {
      toast.warn("Selecione o tipo da tarefa que deseja buscar!")
      return
    }

    let params = {
      id: this.obs.id,
      task_id: this.obs.task_id,
      cnpj: this.obs.cnpj,
      tipo: this.obs.tipo.cod,
      status: this.obs.status,
      finalizado: this.obs.finalizado,
      erro: this.obs.erro,
      dataInicial: this.state.date1,
      dataFinal: this.state.date2,
      conta_id: this.obs.conta_id,
      page: page,
      limit: 15
    }

    await BotsAdminStore.handleGetBots(params)

  };

  onSelect = (row, checked) => {

    if (checked) {

      this.obs.selectedRows.push({ id: row._id, tipo: this.obs.tipo.cod, status: row.status });

    } else {

      let index = this.obs.selectedRows.findIndex(obj => obj.id === row._id);

      if (index !== -1) {
        this.obs.selectedRows.splice(index, 1);
      }

    }

  }

  handleRowSelectAll = async (check, row) => {

    if (check) {

      row?.map(value => {

        this.obs.selectedRows.push({ id: value._id, tipo: this.obs.tipo.cod, status: value.status });

      });

    } else {

      this.obs.selectedRows = [];
    }

  };

  handleDateChange = (val: any) => {
    var string = val.toString();

    var array = string.split(",");

    this.setState({ date1: moment(array[0]).format("YYYY-MM-DD") });
    this.setState({ date2: moment(array[1]).format("YYYY-MM-DD") });

    if (moment(array[0]).format("YYYY-MM-DD") == "Data inválida") {
      this.setState({ date1: "" });
    }

    if (moment(array[1]).format("YYYY-MM-DD") == "Data inválida") {
      this.setState({ date2: "" });
    }

    this.obs.selectedPeriod = val;
  };

  handleBuscaClick = async () => {

    if (!this.obs.tipo.cod) {
      toast.warn("Selecione o tipo da tarefa que deseja buscar!")
      return
    }

    if (this.obs.tipo.cod != "parcelamentos" && (!this.state.date1 || !this.state.date2)) {
      toast.warn("Preencha o campo \"Período criado\".")
      return
    }

    let params = {
      id: this.obs.id,
      task_id: this.obs.task_id,
      cnpj: this.obs.cnpj,
      tipo: this.obs.tipo.cod,
      status: this.obs.status,
      finalizado: this.obs.finalizado,
      erro: this.obs.erro,
      dataInicial: this.state.date1,
      dataFinal: this.state.date2,
      conta_id: this.obs.conta_id,
      page: 1,
      limit: 15
    }

    BotsAdminStore.obs.currentPageBot = 1

    this.obs.loading_solicitacoes = true

    await BotsAdminStore.handleGetBots(params)

    this.obs.loading_solicitacoes = false

  };

  handleViewDetalhes(row) {

    this.obs.tarefa = row

    this.obs.open_detalhes = true

  }

  async handleDownloadFile(row) {

    this.obs.loading_download = true

    await BotsAdminStore.handleDownloadFile(this.obs.tipo.cod, row)

    this.obs.loading_download = false

  }

  async handleAllRestart() {

    this.obs.loading_solicitacoes = true

    let params = {
      id: this.obs.id,
      task_id: this.obs.task_id,
      cnpj: this.obs.cnpj,
      tipo: this.obs.tipo.cod,
      status: this.obs.status,
      finalizado: this.obs.finalizado,
      erro: this.obs.erro,
      dataInicial: this.state.date1,
      dataFinal: this.state.date2,
      conta_id: this.obs.conta_id
    }

    let resp = await BotsAdminStore.handleGetAllBots(params)

    this.obs.loading_solicitacoes = false

    if (resp.length) {

      const label = resp.length === 1 ? "tarefa" : "tarefas";

      if (!window.confirm(`Você está prestes a selecionar ${new Intl.NumberFormat("pt-BR").format(resp.length)} ${label}. Deseja continuar?`)) {
        return
      }

      this.obs.selectedRows = resp

    }

  }

  handleChangeTipo(e: {cod: string, descricao: string}){

    this.obs.tipo = e

    if (e.cod === "parcelamentos") {

      this.obs.selectedPeriod = []
      this.setState({ date1: "", date2: "" });

    }

  }

  render() {

    const formatDetalhes = (row) => {

      return (<IconButton onClick={(e) => this.handleViewDetalhes(row)}>
        <img src="/images/view.png" width="18px"/>
      </IconButton>);

    }

    const formatDownload = (row) => {

      if (!(row.status == 2)) return (<></>)

      const tiposIgnorados = [
        "caixapostal", "calculo", "contestacao", "manifestacao", "solicitacao_sefa", "xml_integration", 
        "dec_ler", "dec_download", "nfe_fazenda", "manifestacao_chaves", "parcelamentos",
        "email", "telegram", "whatsapp", "det"
      ];

      if (tiposIgnorados.includes(this.obs.tipo.cod)) return (<></>)

      return (

        <IconButton onClick={(e) => this.handleDownloadFile(row)} disabled={!(row.status == 2)}>
          <img src="/images/download.svg" width="18px" />
        </IconButton>

      );
    }

    const columns = [
      {
        dataField: '_id',
        text: 'ID',
        isKey: true,
      },
      {
        dataField: 'tipo',
        text: 'Tipo',
        editable: false,
        formatter: (cell) => (this.obs.tipo.cod || "").toUpperCase(),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'cnpj',
        text: 'CNPJ',
        editable: false,
        formatter: (cell, row) => {

          if (cell) {

            return formatCnpj(cell)

          } else {

            if (row.cnpj_destino) {

              return formatCnpj(row.cnpj_destino)

            }

            return "N/A"

          }

        },
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'status',
        text: "Status",
        editable: false,
        formatter: (cell, row) => formatStatusTask(cell, row),
        headerStyle: { width: '300px', textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'status',
        text: "Finalizado",
        editable: false,
        formatter: (cell) => formatFinalizado(cell),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'status',
        text: "Erro",
        editable: false,
        formatter: (cell) => formatErro(cell),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'inserted_at',
        text: 'Criado em',
        editable: false,
        formatter: (cell, row) => formatDate(cell, row._insertedTS),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: '_modifiedTS',
        text: 'Última atualização',
        editable: false,
        formatter: (cell, row) => {
          if (!cell || cell.trim() === "") {
            return "Sem atualização";
          }
          return formatDate(cell, row.updated_at);
        },
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'detalhes',
        text: "Detalhes",
        editable: false,
        formatter: (cell, row) => formatDetalhes(row),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'download',
        text: "Arquivo",
        editable: false,
        formatter: (cell, row) => formatDownload(row),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      }

    ];

    const formatStatusTask = (status, row) => {

      return getTag(status, this.obs.tipo.cod, row);

    }

    const formatDate = (dateString, optionalDate) => {

      const date = new Date((dateString || optionalDate));

      return moment.utc(date).format("DD/MM/YYYY HH:mm");
    };

    const formatFinalizado = (status) => {

      const { tipo } = this.obs;

      const sim = <span style={{ fontSize: 12 }}>SIM</span>;
      const nao = <span style={{ fontSize: 12 }}>NÃO</span>;

      switch (status) {
        case 2:
        case 4:
        case 5: {
          const isTipoIntegracao = ["xml_integration", "sitfis", "download_sefa", "nfe_fazenda", "dec_download"].includes(tipo.cod);

          if (status === 4 && isTipoIntegracao) return nao;
          if (status === 5 && tipo.cod === "solicitacao_sefa") return sim;
          if (status === 5 && tipo.cod === "download_sefa") return nao;

          return sim;
        }

        case 8:
        case 9:
        case 10:
          return sim;

        default:
          return nao;
      }

    };

    const formatErro = (status) => {

      const { tipo } = this.obs;

      const sim = <span className="bot-tag-erro-sim">SIM</span>;
      const nao = <span className="bot-tag-erro-nao">NÃO</span>;

      switch (status) {
        case 3:
        case 8:
        case 9:
          return sim;

        case 4:
          if (["solicitacao_sefa", "xml_integration", "download_sefa", "dec_ler", "nfe_fazenda", "dec_download"].includes(tipo.cod)) {
            return nao;
          }
          return sim;

        case 5:
          if (tipo.cod === "solicitacao_sefa") return nao;
          if (["download_sefa", "xml_integration", "dec_download"].includes(tipo.cod)) return sim;
          return nao;

        default:
          return nao;
      }

    };

    const selectRowProp = {
      mode: 'checkbox',
      clickToSelect: false,
      style: { backgroundColor: '#e9f6ff' },
      onSelect: this.onSelect,
      onSelectAll: this.handleRowSelectAll,
      selected: this.obs.selectedRows?.map(value => value.id),
      nonSelectable: BotsAdminStore.obs.tabelaBots.map(value => {
        if (value.gratuito && value.status == 2 && value.tipo == "receita") return value._id
        if (value.status == 2 && value.tipo == "dec_download") return value._id
      })
    };

    let erros = this.obs.erros_solicitacoes?.map(map_bot => {
      return (
        {
          id: map_bot.id,
          erro: map_bot.error,
        }
      )
    });

    let anexoText = this.obs.tipo.cod ? `${this.obs.tipo.descricao.substring(0, 30)}` : "SELECIONE";

    return (
      <>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 15,
            alignItems: 'flex-end',
          }}
        >
          <FormGroup style={{ flex: '1 1 280px', minWidth: 220 }} label="Buscar ID">
            <InputGroup
              placeholder="Digite o ID"
              value={this.obs.id}
              onChange={(e) => (this.obs.id = e.target.value)}
              fill
            />
          </FormGroup>

          <FormGroup style={{ flex: '1 1 280px', minWidth: 220 }} label="Buscar Task ID">
            <InputGroup
              placeholder="Digite o Task ID"
              value={this.obs.task_id}
              onChange={(e) => (this.obs.task_id = e.target.value)}
              fill
            />
          </FormGroup>

          <FormGroup style={{ flex: '1 1 280px', minWidth: 220 }} label="Buscar Conta ID">
            <InputGroup
              placeholder="Digite o Conta ID"
              value={this.obs.conta_id}
              onChange={(e) => (this.obs.conta_id = e.target.value)}
              fill
            />
          </FormGroup>

          <FormGroup style={{ flex: '1 1 280px', minWidth: 220 }} label="Buscar CNPJ">
            <InputGroup
              placeholder="Digite o CNPJ"
              value={this.obs.cnpj}
              onChange={(e) => (this.obs.cnpj = e.target.value)}
              fill
            />
          </FormGroup>

          <FormGroup style={{ flex: '1 1 240px', minWidth: 220 }} label="Tipo" className="empresaSelect selectValues">
            <DefaultSelect
              items={options}
              itemRenderer={renderItens}
              itemPredicate={filterItens}
              onItemSelect={(e) => this.handleChangeTipo(e)}
              matchTargetWidth={true}
              inputProps={{ placeholder: 'Filtrar um Tipo' }}
            >
              <Button
                className="tipo-select-bots"
                text={anexoText}
                rightIcon="double-caret-vertical"
                alignText={Alignment.LEFT}
                fill
              />
            </DefaultSelect>
          </FormGroup>

          <FormGroup style={{ flex: '1 1 200px', minWidth: 200 }} label="Status">
            <HTMLSelect
              onChange={(e) => (this.obs.status = e.target.value)}
              value={this.obs.status}
              style={{ width: '100%' }}
            >
              {getOptions(this.obs.tipo.cod).map(({ value, label }) => (
                <option key={value} value={value}>
                  {value} - {label}
                </option>
              ))}
            </HTMLSelect>
          </FormGroup>

          <FormGroup style={{ flex: '0 1 200px', minWidth: 180 }} label="Finalizado">
            <HTMLSelect
              onChange={(e) => (this.obs.finalizado = e.target.value)}
              value={this.obs.finalizado}
              style={{ width: '100%' }}
            >
              <option value="todos"> TODOS </option>
              <option value="sim"> SIM </option>
              <option value="nao"> NÃO </option>
            </HTMLSelect>
          </FormGroup>

          <FormGroup style={{ flex: '0 1 200px', minWidth: 180 }} label="Erro">
            <HTMLSelect
              onChange={(e) => (this.obs.erro = e.target.value)}
              value={this.obs.erro}
              style={{ width: '100%' }}
            >
              <option value="todos"> TODOS </option>
              <option value="sim"> SIM </option>
              <option value="nao"> NÃO </option>
            </HTMLSelect>
          </FormGroup>

          <FormGroup style={{ flex: '0 1 360px', minWidth: 280 }} label="Período criado" className="inputsPeriodoBots">
              <DateRangePicker30 onChange={this.handleDateChange} value={this.obs.selectedPeriod} disabled={this.obs.tipo.cod === "parcelamentos"}/>
          </FormGroup>

          <FormGroup style={{ flex: '0 0 auto' }}>
            <MDBBtn className="btnDefault btnBuscarBots" onClick={() => this.handleBuscaClick()} style={{marginBottom: 3}}>
              Buscar
            </MDBBtn>
          </FormGroup>
        </div>

        <MDBBtn
          disabled={this.obs.loading}
          className="btnDefault btnBuscarNfe"
          onClick={() => this.handleRestart()}
          style={{ marginTop: 10 }}
        >
          Reiniciar{" "}
          <span style={{ fontSize: 12 }}>{new Intl.NumberFormat("pt-BR").format(this.obs.selectedRows.length)}</span>{" "}
          {this.obs.selectedRows.length === 1 ? "tarefa selecionada" : "tarefas selecionadas"}
        </MDBBtn>

        <MDBBtn
          disabled={this.obs.loading}
          className="btnDefault btnBuscarNfe"
          onClick={() => this.handleAllRestart()}
          style={{ marginTop: 10, float: "right" }}
        >
          Selecionar todas
        </MDBBtn>

        {/* @ts-ignore */}
        <BootstrapTable keyField="_id" data={BotsAdminStore.obs.tabelaBots} columns={columns} wrapperClasses="TableDefault tabela-excesso" selectRow={selectRowProp} />

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={BotsAdminStore.obs.currentPageBot}
            totalCount={BotsAdminStore.obs.length_bots}
            pageSize={15}
            onPageChange={page => this.handlePageChange(BotsAdminStore.obs.currentPageBot = page)}
          />
        </div>
        <div style={{ marginBottom: 120 }} />

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.open_erros_bots}
          onConfirm={() => this.obs.open_erros_bots = false}
          className="AlertUser"
          intent="primary"
        >
          <h2 className="titleSEFAZ">Erros ocorridos durante a Reinicialização</h2>
          <p style={{ marginBottom: 25, marginTop: -25 }}>
            Para as empresas listadas abaixo, será necessário realizar a reinicialização.
          </p>
          <MDBCol md="12">
            {erros.length &&
              <div className="erroBots">
                <BootstrapTableOld data={erros} hover>
                  <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                  <TableHeaderColumn dataField='id' width='20%'>ID</TableHeaderColumn>
                  <TableHeaderColumn dataField='erro' width='50%'>Erro</TableHeaderColumn>
                </BootstrapTableOld>
              </div>
            }
          </MDBCol>
        </Alert>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.open_detalhes}
          onClose={() => this.obs.open_detalhes = false}
          canOutsideClickCancel={true}
          intent="primary"
        >
          <h2 className="titleSEFAZ">Detalhes</h2>

          <div className="heightResposta">
            <ReactJson collapsed={false} displayDataTypes={false} src={this.obs.tarefa} />
          </div>

        </Alert>

        <LoadingModal open={this.obs.loading_download} onClose={() => this.obs.loading_download = false} title={"Baixando arquivo"} />
        <LoadingModal open={this.obs.loading_solicitacoes} onClose={() => this.obs.loading_solicitacoes = false} title={"Carregando"} />

      </>
    );
  }
}
